/**
 * Utilitaires pour la gestion des GIFs Tenor
 */

export const isGifUrl = (url: string): boolean => {
  if (!url) return false;
  
  // Vérifier si c'est un URL Tenor ou un fichier GIF
  return url.includes('tenor.com') || 
         url.includes('tenor.googleapis.com') ||
         url.includes('.gif') ||
         url.includes('giphy.com');
};

export const isImageUrl = (url: string): boolean => {
  if (!url) return false;
  
  // Vérifier si c'est une image mais pas un GIF
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.bmp', '.svg'];
  const lowerUrl = url.toLowerCase();
  
  return imageExtensions.some(ext => lowerUrl.includes(ext)) && !isGifUrl(url);
};

export const getMediaType = (url: string): 'gif' | 'image' | 'unknown' => {
  if (isGifUrl(url)) return 'gif';
  if (isImageUrl(url)) return 'image';
  return 'unknown';
};

export const formatGifForComment = (gifUrl: string): string => {
  // S'assurer que l'URL du GIF est bien formatée
  return gifUrl;
};

export const TENOR_CONFIG = {
  API_KEY: 'AIzaSyBB1K4zqQ_lRd01pLoNyZ35g2esUqwi0Ic',
  BASE_URL: 'https://tenor.googleapis.com/v2',
  CLIENT_KEY: 'jupipotes',
  CONTENT_FILTER: 'high',
  DEFAULT_LIMIT: 20
};
